import React, { useState, useEffect } from "react";
import DocReviewRow from './DocReviewRow';
import SarasPopup from '../../../library/container/popup/SarasPopup';
import SarasTrans from "../../../library/notifications/SarasTrans";
import * as fn from "../../../helper/uiFunctions";
import * as formJS from '../../cmn/docAutomation/formFunctions';
import { generateKeyParams, loadWorkflowSession, submitForApproval, workFlowTracAction } from './formReviewFunctions'

const DocFormReview = (props) => {
    const { formObject } = props;

    //const viewData = formObject.getFormRow(rowKey, headerKey);
    const [viewData, setViewData] = useState({});
    const [rowData, setRowData] = useState({});
    const [requestedKey, setRequestedKey] = useState({ wsId: '', dId: 0, dtId: 0 });
    const [open, setOpen] = React.useState(false);
    const anchorRef = React.useRef(null);

    const iniFormReview = () => {
        if (formObject && ( requestedKey.wsId !== formObject.masterKeys.wsId || 
                            requestedKey.dId !== formObject.masterKeys.dId || 
                            requestedKey.dtId !== formObject.masterKeys.dtId)) {
            loadWorkflowSession(formObject.masterKeys, onSuccess);
            setRequestedKey(generateKeyParams(formObject.masterKeys));
        }
    }

    useEffect(iniFormReview, [formObject, requestedKey]);

    const onSuccess = (response,requestObject) => {
        // console.log('response 2 ', response);
        if(response.data.mainViewData){
            setViewData(response.data.mainViewData);
            setRowData(response.data.mainViewData.headerRows.WorkFlow.rowValues);
        }
    }

    const onActionSuccess = (response, action) => {
        setRequestedKey({ wsId: '', dId: 0, dtId: 0 });

        //refresh the entire composition
        formJS.refreshDependentForms(action, formObject.viewId, "parent");
    }

    const onMouseEnter = () => {
        setOpen(true);
    }

    const onMouseLeave = () => {
        setOpen(false);
    }

    const onWorkflowAction = (activityId, actionName) => {
        if (actionName === "reject") {
            workFlowTracAction(formObject.masterKeys, activityId, 3, onActionSuccess);

        } else if (actionName === "approve") {
            workFlowTracAction(formObject.masterKeys, activityId, 2, onActionSuccess);
        }
        else {
            if (!(activityId && actionName)) {
                submitForApproval(formObject.masterKeys, onActionSuccess);
            }
        }
    }

    const renderWorkflow = () => {
        // if (fn.compareNumber(rowData.submitContainer.dataList.isHid, 0)) {
        //     return (
        //         <div className="btnSubmitApproval" onClick={onWorkflowAction}><SarasTrans value="Submit For Approval" /></div>
        //     )
        // }

        return (
            <>
            {fn.compareNumber(rowData.submitContainer.dataList.isHid, 0) ?
                <div className="btnSubmitApproval" onClick={onWorkflowAction}><SarasTrans value="Submit For Approval" /></div> : null}
            {fn.compareNumber(reviewStatus.dataList.isHid, 0) ?
            <div className="uiWorkApproval uiInline"
                onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
                <div className="uiBoxTitle">
                    <span ref={anchorRef} 
                        className={reviewStatus.dataList.colCssClass} title={reviewStatus.dataList.title || ''}
                        style={{ height: "30px" }}
                    >
                        {reviewStatus.val}
                    </span>
                </div>
                <div className="uiAppWFAction">
                    <div className="phSectionContents">
                        <SarasPopup anchorRef={anchorRef} open={open}>
                            <ul className="uiApvWrkFlwActivity">
                                {
                                    Object.values(reviewStatus.childRows[0].rowValues).map((row) => (
                                        <DocReviewRow viewData={row} onClick={onWorkflowAction} />
                                    ))

                                }
                            </ul>
                        </SarasPopup>
                    </div>
                </div>
            </div> 
            : null}
            </>
        )
    }

    if (!(Object.keys(viewData).length > 0 && Object.keys(rowData).length > 0))
        return (null)

    const reviewStatus = rowData.reviewStatus;

    return (
        <>
            {renderWorkflow()}
        </>
    )
}

export default DocFormReview